'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

exports.canUseDOM = canUseDOM;